import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "guidepage",
    component: () =>
      import(/* webpackChunkName: "guidepage" */ "../views/guidepage.vue"),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
